import { type LoadErrorStatus } from "owa-mail-list-store";
import { DatapointStatus } from "owa-analytics-types";

/**
 * Maps the table's LoadErrorStatus to the DatapointStatus the MailListLoad datapoint
 * should end with. Follows the SelectMailItem / reading-pane convention: errors returned
 * by the server end with ServerError, while client-side / offline failures end with ClientError.
 * Returns undefined when there is no error, so the datapoint ends with success.
 */
export default function getMailListLoadErrorStatus(loadErrorStatus: LoadErrorStatus): DatapointStatus | undefined {
    switch (loadErrorStatus) {
        case 1:
        case 4:
            // Server responded with an error (e.g. ErrorAccessDenied or an unmapped response code).
            return DatapointStatus.ServerError;
        case 3:
        case 2:
            // Client-side failure: network/offline or an unexpected client error.
            return DatapointStatus.ClientError;
        default:
            return undefined;
    }
}
